var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KlevuConfig } from "../../index.js";
import { get } from "../fetch.js";
import { objectToQueryParameters } from "../../utils/index.js";
/**
 *
 * @param id Id of query response to find
 * @param response Raw API response from server
 * @param product Id of product to find
 * @param languageCode Language code to process in
 * @returns
 */
export function getAnnotationsForProduct(response, productId, languageCode) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const prod = (_a = response.records) === null || _a === void 0 ? void 0 : _a.find((s) => s.id === productId);
        if (!prod) {
            return undefined;
        }
        const paramaters = {
            query: response.meta.searchedTerm,
            title: prod.name,
            category: prod.category,
            languageCode: languageCode,
        };
        const url = "https://nlp-services.ksearchnet.com/" +
            KlevuConfig.getDefault().apiKey +
            "/annotations" +
            objectToQueryParameters(paramaters);
        return yield get(url);
    });
}
